import {Component} from "@angular/core";
import {DialogService} from "../bootstrap-modal/dialog.service";
import {DialogComponent} from "../bootstrap-modal/dialog.component";
import {Observable} from "rxjs";
import {ProjectService} from "./project.service";
import {handleErrors} from "../misc/handle-errors.decorator";
import {FormControl, FormGroup} from "@angular/forms";

@Component({
  templateUrl: "./project-create-dialog.template.pug",
  providers: [
    ProjectService,
  ],
})
export class ProjectCreateDialogComponent extends DialogComponent<void, boolean> {
  public error: Error;
  public projectName: string;
  public region: string;
  public targetSystem: string;
  public form: FormGroup = new FormGroup({
    projectName: new FormControl(),
    region: new FormControl(),
    targetSystem: new FormControl(),
  });

  static showCreateDialog(dialogService: DialogService): Observable<boolean> {
    return dialogService.addDialog(ProjectCreateDialogComponent, undefined, {backdropColor: "rgba(0, 0, 0, 0.5)"});
  }

  cancel(): void {
    this.result = false;
    this.close();
  }

  @handleErrors()
  async save(): Promise<void> {
    const form = this.form.getRawValue();
    await this.projectService.create(form.projectName, form.region, form.targetSystem).toPromise();
    this.result = true;
    this.close();
  }

  constructor(
    public dialogService: DialogService,
    public projectService: ProjectService,
  ) {
    super(dialogService);
  }
}
